import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "status-danger",
  "use": "status-danger-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 19\" id=\"status-danger\"><defs><style>#status-danger .cls-1{fill:#fff}</style></defs><title>资源 5</title><g id=\"status-danger_图层_2\" data-name=\"图层 2\"><g id=\"status-danger_图层_1-2\" data-name=\"图层 1\"><circle class=\"cls-1\" cx=\"9.5\" cy=\"9.5\" r=\"9.5\" /><path d=\"M9.5 1.5a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm-.75 3.55a.62.62 0 0 1 .64-.59.61.61 0 0 1 .59.59v5.67a.62.62 0 1 1-1.23 0zm.62 8.65a.69.69 0 1 1 .69-.69.69.69 0 0 1-.69.69z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/status-danger.svg
// module id = R6b8
// module chunks = 6